import {
  selectFiscalCapitalBalanceList,
  selectFiscalCapitalBalanceListCount,
  selectFiscalCapitalBalanceQueryOptions,
  selectFiscalCapitalBalanceSummaryList,
  selectFiscalCapitalBalanceSummaryCount,
  selectFiscalCapitalBalanceKpis,
  selectAccountingCapitalBalanceList,
  selectAccountingCapitalBalanceListCount,
  selectAccountingCapitalBalanceQueryOptions,
  selectAccountingCapitalBalanceSummaryList,
  selectAccountingCapitalBalanceSummaryCount,
  selectAccountingCapitalBalanceKpis,
  selectFiscalTerminationAuditList,
  selectFiscalTerminationAuditCount,
  selectFiscalTerminationAuditQueryOptions,
  selectAccountingTerminationAuditList,
  selectAccountingTerminationAuditCount,
  selectAccountingTerminationAuditQueryOptions
} from 'src/store/selectors/capitalBalanceSelectors';
import {
  loadFiscalCapitalBalance,
  LOAD_FISCAL_CAPITAL_BALANCE,
  LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  CLEAR_FISCAL_CAPITAL_BALANCE,
  downloadExcelFiscalCapitalBalance,
  loadFiscalCapitalBalanceSummary,
  loadFiscalCapitalBalanceKpis,
  loadAccountingCapitalBalance,
  LOAD_ACCOUNTING_CAPITAL_BALANCE,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  downloadExcelAccountingCapitalBalance,
  loadAccountingCapitalBalanceSummary,
  loadAccountingCapitalBalanceKpis,
  loadFiscalTerminationAudit,
  clearFiscalTerminationAudit,
  LOAD_FISCAL_TERMINATION_AUDIT,
  loadAccountingTerminationAudit,
  clearAccountingTerminationAudit,
  LOAD_ACCOUNTING_TERMINATION_AUDIT
} from 'src/store/actions/capitalBalanceActions';

export const FISCAL_CAPITAL_BALANCE_CONFIG = {
  selectors: {
    selectList: selectFiscalCapitalBalanceList,
    selectCount: selectFiscalCapitalBalanceListCount,
    selectQueryOptions: selectFiscalCapitalBalanceQueryOptions,
    selectSummaryList: selectFiscalCapitalBalanceSummaryList,
    selectSummaryCount: selectFiscalCapitalBalanceSummaryCount,
    selectKpis: selectFiscalCapitalBalanceKpis
  },
  actions: {
    load: loadFiscalCapitalBalance,
    loadSummary: loadFiscalCapitalBalanceSummary,
    downloadExcel: downloadExcelFiscalCapitalBalance,
    loadKpis: loadFiscalCapitalBalanceKpis
  },
  loadActionType: LOAD_FISCAL_CAPITAL_BALANCE,
  loadSummaryActionType: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  clearActionType: CLEAR_FISCAL_CAPITAL_BALANCE,
  titleKey: 'NAVIGATION.FISCAL_CAPITAL_BALANCE',
  terminationKpiContextKey: 'CAPITAL_BALANCE.TERMINATION_KPI_CONTEXT_FISCAL',
  summaryTitleKey: 'NAVIGATION.FISCAL_CAPITAL_BALANCE_SUMMARY',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};

export const ACCOUNTING_CAPITAL_BALANCE_CONFIG = {
  selectors: {
    selectList: selectAccountingCapitalBalanceList,
    selectCount: selectAccountingCapitalBalanceListCount,
    selectQueryOptions: selectAccountingCapitalBalanceQueryOptions,
    selectSummaryList: selectAccountingCapitalBalanceSummaryList,
    selectSummaryCount: selectAccountingCapitalBalanceSummaryCount,
    selectKpis: selectAccountingCapitalBalanceKpis
  },
  actions: {
    load: loadAccountingCapitalBalance,
    loadSummary: loadAccountingCapitalBalanceSummary,
    downloadExcel: downloadExcelAccountingCapitalBalance,
    loadKpis: loadAccountingCapitalBalanceKpis
  },
  loadActionType: LOAD_ACCOUNTING_CAPITAL_BALANCE,
  loadSummaryActionType: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  clearActionType: CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  titleKey: 'NAVIGATION.ACCOUNTING_CAPITAL_BALANCE',
  terminationKpiContextKey:
    'CAPITAL_BALANCE.TERMINATION_KPI_CONTEXT_ACCOUNTING',
  summaryTitleKey: 'NAVIGATION.ACCOUNTING_CAPITAL_BALANCE_SUMMARY',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};

export const FISCAL_TERMINATION_AUDIT_CONFIG = {
  selectors: {
    selectList: selectFiscalTerminationAuditList,
    selectCount: selectFiscalTerminationAuditCount,
    selectQueryOptions: selectFiscalTerminationAuditQueryOptions
  },
  actions: {
    load: loadFiscalTerminationAudit,
    clear: clearFiscalTerminationAudit
  },
  loadActionType: LOAD_FISCAL_TERMINATION_AUDIT,
  titleKey: 'NAVIGATION.FISCAL_CAPITAL_BALANCE_TERMINATION_AUDIT',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};

export const ACCOUNTING_TERMINATION_AUDIT_CONFIG = {
  selectors: {
    selectList: selectAccountingTerminationAuditList,
    selectCount: selectAccountingTerminationAuditCount,
    selectQueryOptions: selectAccountingTerminationAuditQueryOptions
  },
  actions: {
    load: loadAccountingTerminationAudit,
    clear: clearAccountingTerminationAudit
  },
  loadActionType: LOAD_ACCOUNTING_TERMINATION_AUDIT,
  titleKey: 'NAVIGATION.ACCOUNTING_CAPITAL_BALANCE_TERMINATION_AUDIT',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};
